// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getOpinometros as listOpinometroAPI,
    getOpinometro as getOpinometroAPI,
    addOpinometro as addOpinometroAPI,
    duplicateOpinometro as duplicateOpinometroAPI,
    updateOpinometro as updateOpinometroAPI,
    deleteOpinometro as deleteOpinometroAPI,
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { opinometroApiResponseError, opinometroApiResponseSuccess } from './actions';
import { OpinometroActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getOpinometro({ payload: { id } }) {
    try {
        const response = yield call(getOpinometroAPI, id);
        const opinometroItem = response.data.data;
        yield put(opinometroApiResponseSuccess(OpinometroActionTypes.GET_OPINOMETRO, opinometroItem));
    } catch (error) {
        yield put(opinometroApiResponseError(OpinometroActionTypes.GET_OPINOMETRO, error));
    }
}

function* addOpinometro({ payload: opinometro }) {
    try {
        const response = yield call(addOpinometroAPI, { ...opinometro })
        const opinometroItem = response.data
        yield put(opinometroApiResponseSuccess(OpinometroActionTypes.ADD_OPINOMETRO, opinometroItem))
    } catch (error) {
        yield put(opinometroApiResponseError(OpinometroActionTypes.ADD_OPINOMETRO, error))
    }
}

function* duplicateOpinometro({ payload: opinometro }) {
    try {
        const response = yield call(duplicateOpinometroAPI, { ...opinometro })
        const opinometroItem = response.data
        yield put(opinometroApiResponseSuccess(OpinometroActionTypes.DUPLICATE_OPINOMETRO, opinometroItem))
    } catch (error) {
        yield put(opinometroApiResponseError(OpinometroActionTypes.DUPLICATE_OPINOMETRO, error))
    }
}

function* updateOpinometro({ payload: opinometro }) {
    try {
        const response = yield call(updateOpinometroAPI, { ...opinometro })
        const opinometroItem = response.data.data
        yield put(opinometroApiResponseSuccess(OpinometroActionTypes.UPDATE_OPINOMETRO, opinometroItem))
    } catch (error) {
        yield put(opinometroApiResponseError(OpinometroActionTypes.UPDATE_OPINOMETRO, error))
    }
}
function* deleteOpinometro({ payload: { id } }) {
    try {
        const response = yield call(deleteOpinometroAPI, id)
        const opinometroItem = response.data.id
        yield put(opinometroApiResponseSuccess(OpinometroActionTypes.DELETE_OPINOMETRO, opinometroItem))
    } catch (error) {
        yield put(opinometroApiResponseError(OpinometroActionTypes.DELETE_OPINOMETRO, error))
    }
}

/**
 * List contactos
 */
function* listOpinometro({ payload: params }) {
    try {
        const response = yield call(listOpinometroAPI, { ...params });
        const listaOpinometros = response.data.data;
        yield put(opinometroApiResponseSuccess(OpinometroActionTypes.LIST_OPINOMETROS, listaOpinometros));
    } catch (error) {
        yield put(opinometroApiResponseError(OpinometroActionTypes.LIST_OPINOMETROS, error));
    }
}


export function* watchGetOpinometro(): any {
    yield takeEvery(OpinometroActionTypes.GET_OPINOMETRO, getOpinometro);
}

export function* watchListOpinometro(): any {
    yield takeEvery(OpinometroActionTypes.LIST_OPINOMETROS, listOpinometro);
}

export function* watchAddOpinometro(): any {
    yield takeEvery(OpinometroActionTypes.ADD_OPINOMETRO, addOpinometro)
}

export function* watchDuplicateOpinometro(): any {
    yield takeEvery(OpinometroActionTypes.DUPLICATE_OPINOMETRO, duplicateOpinometro)
}

export function* watchUpdateOpinometro(): any {
    yield takeEvery(OpinometroActionTypes.UPDATE_OPINOMETRO, updateOpinometro)
}
export function* watchDeleteOpinometro(): any {
    yield takeEvery(OpinometroActionTypes.DELETE_OPINOMETRO, deleteOpinometro)
}


function* opinometroSaga(): any {
    yield all([
        fork(watchGetOpinometro),
        fork(watchListOpinometro),
        fork(watchAddOpinometro),
        fork(watchDuplicateOpinometro),
        fork(watchUpdateOpinometro),
        fork(watchDeleteOpinometro),
    ]);
}

export default opinometroSaga;
